import { StyledReview } from '@/components/styles';
import { Stars } from '@/components';
import Icon from '@/assets/icons';

const formateDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day > 9 ? day : '0' + day}.${month > 9 ? month : '0' + month}.${year}`;
};

export default function Review({ id, name, service, review, gender: sexFromProps, rating, approve_date, p, ...props }) {
  const sex = sexFromProps || 'woman';
  const date = formateDate(approve_date);

  return (
    <StyledReview p={p} {...props}>
      <StyledReview.Header>
        <StyledReview.Author>
          <StyledReview.Img>
            <Icon name={sex} width={50} height={55} />
          </StyledReview.Img>
          <div>
            <StyledReview.Name>{name}</StyledReview.Name>
            {service && (
              <StyledReview.Service>
                <b>Service:</b> {service.title}
              </StyledReview.Service>
            )}
          </div>
        </StyledReview.Author>
        <StyledReview.Rating>
          <Stars rating={rating || 0} />
          <StyledReview.Date>{date}</StyledReview.Date>
        </StyledReview.Rating>
      </StyledReview.Header>
      <StyledReview.Text>{review}</StyledReview.Text>
    </StyledReview>
  );
}
